import { Component, OnInit } from '@angular/core';
import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';
import { AlarmsService } from '../services/alarms-service.service';
import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { DxChartModule, DxChartComponent, DxButtonModule, DxDateBoxModule } from 'devextreme-angular';
import moment from 'moment';
import { CurrentAccount } from '../models/AccountModel';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
    selector: 'app-contact-us-container',
    templateUrl: './contact-us-container.component.html',
    styleUrls: ['./contact-us-container.component.css']
})

export class ContactUsContainerComponent implements OnInit {
  streetAddress: string;
  cityStateZip: string;
  acctNumber: string;
  showSuccess: boolean;
  showError: boolean;
  subject: string;
  message: string;
  error: string;
  now = Date.now();
  minDate = moment(this.now).format('LLL');
  currentAccount: CurrentAccount;
  showButton: boolean;
  acctIndexID: any;

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService,
    private alarmsService: AlarmsService,
    private spinnerService: Ng4LoadingSpinnerService
   ) { }
  ngOnInit() {
    this.showSuccess = false;
    this.showError = false;
    this.showButton = true;

    this.loginService.getUserContext()
      .subscribe((ctx) => {
        if (ctx) {
          this.acctIndexID = this.getActiveAcctIndex(ctx.accountsWithDevices, ctx.activeAcctId);

          let accountsWithDevices = ctx.accountsWithDevices[this.acctIndexID];

          this.currentAccount = {
            OrgUnitId: accountsWithDevices.orgUnitId,
            DeviceId: accountsWithDevices.deviceId,
            AccountId: accountsWithDevices.accountId
          }
        }
      });
  }

  getActiveAcctIndex(accts, activeAcctID) {
    var acctIDIndex = 0;

    //get correct acct based on selected active acctid
    for (var i = 0; i < accts.length; i++) {
      let acct = accts[i];
      if (acct.accountId == activeAcctID) {
        acctIDIndex = i;
        break;
      }
    }
    return acctIDIndex;
  }

  sendSupportMessage(currentAccount, subject, message) {
    if (subject === undefined || message === undefined) {
      this.error = "You must enter a subject and message, neither can be left blank.";
      this.showError = true;
    } else {
      this.spinnerService.show();
      let supportMessage = {
        AccountId: this.currentAccount.AccountId.toString(),
        OrgUnitId: this.currentAccount.OrgUnitId.toString(),
        Subject: this.subject,
        Message: this.message
      }
      this.accountDetailsService.sendSupportMessage(supportMessage)
      .subscribe((res) => {
        if (res.success) {
          this.subject = undefined;
          this.message = undefined;
          this.showSuccess = true;
          this.showButton = false;
        } else {
          this.showError = true;
          this.error = "An error occurred. Please contact your system administrator.";
        }
        () => this.spinnerService.hide();
      });
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/contact-us-container/contact-us-container.component.ts